import { TBookingPayment } from "../../types/types";

export const BookingPayments = (props: { bookingPayments: TBookingPayment[] }) => {
    const { bookingPayments } = props;
console.log("BookingPayments component received payments:", bookingPayments);
    if (!bookingPayments || bookingPayments.length === 0) {
        return <p>None</p>;
    }
    return (
        <table className="table table-sm table-striped">
            <tbody>
                <tr className="small">
                    <td>PID</td>
                    <td>BID</td>
                    <td>Amount</td>
                    <td>Reference</td>
                    <td>Agent ID</td>
                    <td>Date</td>
                </tr>
                {bookingPayments.map((payment) => (
                    <tr key={payment.payment_id} className="small">
                        <td>{payment.payment_id}</td>
                        <td>{payment.booking_id}</td>
                        <td>R{payment.amount}</td>
                        <td>{payment.reference}</td>
                        <td>{payment.user_id}</td>
                        <td>
                            {payment.created_at}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};